module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Opret ansættelse")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.step === 1) ? [_c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Ansættelsen hentes fra lønsystemet. Indtast det " + _vm._s(_vm.numberLabel.toLowerCase()) + ",\n          som ansættelsen har i lønsystemet, så importeres stilling, periode og\n          beskæftigelsesgrad automatisk.\n        ")]), _vm._v(" "), (_vm.needsCpr) ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("CPR-nummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpr),
      expression: "cpr"
    }],
    ref: "cpr_input",
    staticClass: "d-input",
    class: {
      'is-invalid': !!_vm.cprError
    },
    attrs: {
      "type": "text",
      "placeholder": "ddmmåå-nnnn",
      "inputmode": "numeric",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.cpr)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cpr = $event.target.value
      }, function($event) {
        _vm.errorMessage = ''
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onFetch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.cprError) ? _c('p', {
    staticClass: "text-explainer text-error marg-05-top"
  }, [_vm._v(_vm._s(_vm.cprError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n            " + _vm._s(_vm.numberLabel) + "\n            "), (_vm.maxLength) ? _c('span', {
    staticStyle: {
      "font-size": "7px"
    }
  }, [_vm._v("(max " + _vm._s(_vm.maxLength) + " cifre)")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    ref: "number_input",
    staticClass: "d-input",
    class: {
      'is-invalid': !!_vm.codeError || !!_vm.errorMessage
    },
    attrs: {
      "type": "text",
      "maxlength": _vm.maxLength || 20
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, _vm.onCodeInput],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onFetch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.codeError) ? _c('p', {
    staticClass: "text-explainer text-error marg-05-top"
  }, [_vm._v(_vm._s(_vm.codeError))]) : (_vm.errorMessage) ? _c('p', {
    staticClass: "text-explainer text-error marg-05-top"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onFetch
    }
  }, [_vm._v("\n            Hent ansættelse\n          ")])])])] : [_c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "import-success"
  }, [_c('p', {
    staticClass: "import-success__title"
  }, [_vm._v("Ansættelsen er hentet fra lønsystemet")]), _vm._v(" "), _vm._l((_vm.importedSchoolEmployments), function(employment) {
    return _c('p', {
      key: employment.id,
      staticClass: "import-success__employment"
    }, [_c('strong', [_vm._v(_vm._s(employment.employment_number) + " - " + _vm._s(employment.source_title || employment.title))]), _c('br'), _vm._v("\n            " + _vm._s(_vm.formatDate(employment.start_date)) + " – " + _vm._s(_vm.formatDate(employment.end_date)) + "\n            "), (employment.employment_percent) ? [_vm._v(" · " + _vm._s(_vm.formatPercent(employment.employment_percent)) + "%")] : _vm._e(), _vm._v(" "), (employment.organisation) ? [_vm._v(" · " + _vm._s(employment.organisation))] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Stillingskategori")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentTemplateId),
      expression: "employmentTemplateId"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentTemplateId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg stillingskategori")]), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
    return _c('option', {
      key: template.id,
      domProps: {
        "value": template.id
      }
    }, [_vm._v("\n              " + _vm._s(template.title) + "\n            ")])
  })], 2), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "text-explainer text-error marg-05-top"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.onSkipTemplate
    }
  }, [_vm._v("\n            Spring over\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.employmentTemplateId || _vm.isSubmitting,
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onAssignTemplate
    }
  }, [_vm._v("\n            Gem stillingskategori\n          ")])])])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e4c8cd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/EmploymentImportModal.vue
// module id = 2071
// module chunks = 1